export default __webpack_public_path__ + "static/media/ic-animals-sheep.bbf0815b.svg";